import { COMMON_EVENT_NAMES } from "../../constants";

export const EVENT_NAME = {
  FAVORITED: "Track Favorited",
  UNFAVORITED: "Track Unfavorited",
  UNSELECT: "unselect",
  NAVIGATED: COMMON_EVENT_NAMES.NAVIGATED
};
